module.exports = __webpack_public_path__ + "static/media/Documents.30b14ebc.png";